import React, { useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import logo from "../assets/images/conecta-logo.svg";
import republic from "../assets/images/republica-mocambique.svg";
import { ToastContainer } from "react-toastify";
import { Column } from "carbon-components-react";

const PublicLayout = () => {
  useEffect(() => {
    document.body.classList.remove("admin-page");
    document.body.classList.add("public-page");
  }, []);
  return (
    <>
      <header>
        <div className="bx--grid">
          <Column sm={12} md={12} lg={10} xlg={10} className="header-wrap">
            <h1 className="logo">
              <a href="/">
                <img
                  src={republic}
                  alt="Ligações de Consumo - Conecta Negócios"
                  width="200px"
                />
              </a>
              <a href="/">
                <img
                  src={logo}
                  alt="Ligações de Consumo - Conecta Negócios"
                  width="200px"
                />
              </a>
            </h1>
            <nav id="navbar" className="navbar">
              <ul>
                <li>
                  <Link to="/" className="nav-link">
                    Login
                  </Link>
                </li>
                <li>
                  <Link to="/regista-te" className="nav-link">
                    Regista-te
                  </Link>
                </li>
                {/* <li>
                  <Link to="/reclamacoes" className="nav-link">
                    Reclamações
                  </Link>
                </li> */}
              </ul>
              <i className="bi bi-list mobile-nav-toggle"></i>
            </nav>
          </Column>
        </div>
      </header>
      <main className="bx--grid main">
        <Column sm={12} md={12} lg={10} xlg={10} style={{ margin: "auto" }}>
          <Outlet />
          <ToastContainer
            theme="colored"
            position="top-right"
            autoClose={8000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Column>
      </main>
    </>
  );
};

export default PublicLayout;
